import { inject, Injectable } from '@angular/core';
import { GrowlerService } from '@app/components/core/growler/service/growler.service';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import type { IContentStore } from '@app/interface/content/content-store.interface';
import { GROWLER_KEYS } from '@app/service/add-to-cart-growler/growler-content-keys';

/**
 * Owns all personalization-related content-key resolution and growler dispatch.
 * Controllers must NOT call GrowlerService directly for personalization alerts.
 */
@Injectable({ providedIn: 'root' })
export class PersonalizationGrowlerService {
  private readonly growlerService = inject(GrowlerService);
  private readonly contentStore = inject<IContentStore>(angularjs.ContentStore);

  showPersonalizationNeeded(): void {
    this.growlerService.warning({
      title: this.contentStore.translate(GROWLER_KEYS.PERSONALIZATION_NEEDED_TITLE),
      message: this.contentStore.translate(GROWLER_KEYS.PERSONALIZATION_NEEDED_MESSAGE),
      closeable: true,
      growlerStyle: 'floating'
    });
  }

  showAutoFillFailed(studentName: string): void {
    this.growlerService.warning({
      title: this.contentStore.translate(GROWLER_KEYS.AUTOFILL_FAILED_TITLE, { studentName }),
      message: this.contentStore.translate(GROWLER_KEYS.AUTOFILL_FAILED_MESSAGE),
      closeable: true,
      growlerStyle: 'floating'
    });
  }
}
